<template>
<div>
  <div class="login-container">
    <img src="/static/logo.png" alt="VeggieFactory log" height="320" width="320">
    <div class="card">
        <div class="card-content">
            <b-field label="Email">
                <b-input type="email" v-model="email"></b-input>
            </b-field>
            <b-field label="Password">
                <b-input type="password" password-reveal v-model="password"></b-input>
            </b-field>
            <p class="has-text-danger">{{error}}</p>
            <button class="button is-primary full-width-button" :class="{'is-loading': isLoading}" @click="login">Login</button>
        </div>

    </div>
    <!-- <img class="background" src="/static/tb.jpg" > -->
 
    </div>
       <!--   <section class="section is-contact has-background is-medium">
        <div class=container>
          <div class=section-media> <img role=presentation src="/static/budo.png"  />
          </div>
        </div>
      </section> -->
    
 </div>
</template>

<script>
import LoginService from "./service";
import Firebase from '../../lib/Firebase';

import Firestore from '../../lib/Firestore';
export default {
name: "login",

  data() {
    return {
      isLoading: false,
      email:
      process.env.NODE_ENV === "development" ? "admin@travelaam.com" : null,
      password:
      process.env.NODE_ENV === "development" ? "travel@123" : null,
      error: null,
      userdetail : null,
      data : null,
    };
  },

 methods: {



 login() {
        this.isLoading = true   
        Firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
          (user) => {
              
              if (user && user.uid) {
                
                    props: {userprop: this.user}
                let docRef = Firebase.firestore().collection("users").doc(user.uid);
                docRef.get().then(doc => {
                 
                if (doc.exists) {
                  let data = doc.data();
                    if ( data.role === "admin") {
                          
                    console.log(data.role , user.email)
                    this.isLoading = false; 
                    this.$router.push("/app/analytics");
                   

                } else {
                  console.log(data.role , user.email)
                  this.isLoading = false; 
                    this.$toast.open({
                    duration: 6000,
                    message: `You are not Admin! Please contact Head Office!`,
                    position: 'is-top',
                    type: 'is-danger'
                })
                 // alert('You are not admin!');
                  console.log("No such document!");
                } }
              })
             }
            },
          (err) => {
            alert('Oops. ' + err.message)
                      this.isLoading = false;

          }
        );
  },
  
  }
 };


</script>

<style scoped>
img {
  margin-bottom: 1rem;
}
.login-container {
  background-color: #ffffff;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-size: 400px;
  background-repeat: repeat-x;
  background-position: right 36rem;
  background-image:
    url(/static/tb.jpg); 
}
/* .background{
   height: 50px;

 background-repeat: repeat-y;
  margin-top: 0rem;
  
  border-radius: 50%;
} */
</style>



// WEBPACK FOOTER //
// src/pages/login/Login.vue